import { enableProdMode, provideAppInitializer, inject, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { environment } from './environments/environment';
import { UserService } from './app/services';
import { Title, BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { OrderControllerService } from './app/services/order/order-controller.service';
import { EnvironmentService } from './app/services/environment/environment.service';
import { SwankAuthenticationEnvironmentService, SwankAuthenticationEnvironmentServiceFactory, SwankAuthenticationModule } from '@swank/authentication';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SwankResultInterceptor } from '@swank/http-interceptors';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { insightRoutes } from './app/insight-routing';
import { ToastrModule } from 'ngx-toastr';
import { InsightComponent } from './app/components/insight-app/insight.component';

if (environment.production) {
  enableProdMode();
}

function getUserInitializationFactory(userService: UserService): () => Promise<any> {
  return (): Promise<any> => userService.getUser().toPromise();
}

bootstrapApplication(InsightComponent, {
  providers: [
    importProvidersFrom(
      SwankAuthenticationModule,
      BrowserModule,
      ReactiveFormsModule,
      ToastrModule.forRoot()
    ),
    provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true }),
    provideRouter(insightRoutes),
    EnvironmentService,
    UserService,
    Title, // allows us to set page title
    OrderControllerService,
    { provide: SwankAuthenticationEnvironmentService, useFactory: SwankAuthenticationEnvironmentServiceFactory },
    provideAppInitializer(() => {
      const initializerFn = (getUserInitializationFactory)(inject(UserService));
      return initializerFn();
    }),
    { provide: HTTP_INTERCEPTORS, useClass: SwankResultInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations()
  ]
}).catch(err => console.error(err));
